<template>
  <div class="w-full h-full px-4 pb-4 box-border flex flex-col overflow-auto">
    <div class="flex-1 px-3 py-1 box-border flex flex-col rounded-small bg-theme-gray">
      <textarea
        class="py-0.5 flex-1 box-border outline-none resize-none bg-transparent"
        :maxlength="maxlength"
        :placeholder="placeholder"
        v-model="settingValue"
      ></textarea>
      <div class="w-full text-right text-theme-text-gray text-small leading-22">
        {{settingValue.length}}/{{maxlength}}
      </div>
    </div>
    <p class="w-full mt-1 flex items-center text-yellow-theme">
      <i class="el-icon-warning-outline text-small mr-1"></i>
      <span class="text-small leading-22">
        每个维度名称建议控制在 10 个字以内，最多支持 30 字
      </span>
    </p>
  </div>
</template>

<script>
import { addDimension } from '@/api/wenjuan/dimensionScore';

export default {
  name: 'DimensionSettingField',
  data() {
    return {
      placeholder: '请点此添加维度（每行一个）\n组织能力\n创新能力\n......',
      maxlength: 1000,
      settingValue: ''
    }
  },
  inject: {
    setFullActive: {
      default: () => () => {}
    },
    topSource: {
      default: () => ({})
    }
  },
  mounted() {
    this.topSource.onNextBefore = this.checkText.bind(this);
  },
  beforeDestroy() {
    this.topSource.onNextBefore = null;
  },
  methods: {
    checkText() {
      if (this.settingValue.trim().length === 0) {
        this.$message.warning('请添加维度');
        return false;
      } else {
        const arrValue = this.settingValue.split('\n').map((val) => val.trim())
        const dimensionNames = arrValue.map((val) => {
          return val.substr(0, 30);
        });
        return new Promise((resolve, reject) => {
          this.topSource.nextLoading = true;
          addDimension(dimensionNames).then((res) => {
            const { code, msg } = res.data || {};
            if (code === 0) {
              this.$message.success('添加维度成功');
              this.setFullActive();
              resolve();
            } else {
              this.$message.error(msg ?? '添加维度失败');
              reject();
            }
          }).catch(() => {
            this.$message.error('添加维度失败');
            reject();
          }).finally(() => {
            this.topSource.nextLoading = false;
          });
        });
      }
    }
  }
}
</script>